export default __webpack_public_path__ + "static/media/checkin.ec417a3a.png";